<template>
  <div>
    <v-row>
      <v-col cols="12">
        <AddressStructuredField
          :value="v.address.$model"
          @change="onChangeAddress($event)"
          :v="v.address"
          label="Адрес места нахождения, указанный в ЕГРЮЛ"
          :global-disabled="disabled"
          :notice-recovery="noticeRecovery"
					@blur="v.address.$touch"
          :translationKey="translationKey ? `${translationKey}.addr` : undefined"
        />
      </v-col>
      <v-col cols="12">
        <v-checkbox
          @change="onEqualAddress"
          v-model="v.addressesMatch.$model"
          label="Фактический адрес совпадает с адресом указанном в ЕГРЮЛ"
          hide-details
          :disabled="disabled"
        />
      </v-col>
      <v-col cols="12">
        <AddressStructuredField
          :value="v.factAddress.$model"
          @change="v.factAddress.$model = $event"
          :v="v.factAddress"
          :key="componentKey"
          :global-disabled="v.addressesMatch.$model || disabled"
          label="Фактический адрес"
          :notice-recovery="noticeRecovery"
					@blur="v.factAddress.$touch"
          :translationKey="translationKey ? `${translationKey}.factAddr` : undefined"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';

import { required } from 'vuelidate/lib/validators';

import { getValidationErrorText } from '@/utils/validate';
import AddressStructuredField, {
  addressValidate,
} from '@/components/base/AddressStructuredField';

export const organizationModel = {
  address: '',
  isEqualAddress: false,
  factAddress: '',
};

export const getOrganizationValidation = () => ({
  address: {
    required,
    ...addressValidate(),
  },
  isEqualAddress: {},
  factAddress: {
    ...addressValidate(),
  },
});

export default {
  name: 'AddressEGRUL',
  props: {
    v: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    noticeRecovery: {
      type: Boolean,
    },
    translationKey: {
      type: String,
    }
  },
  components: {
    AddressStructuredField,
  },
  data: () => ({
    getValidationErrorText,
    componentKey: 0,
    isEqualAddress: false,
  }),
  methods: {
    onEqualAddress() {
      if (this.v.addressesMatch.$model) {
        this.copyAddress();
      }
    },
    onChangeAddress($event) {
      this.v.address.$model = $event;
      if (this.v.addressesMatch.$model) {
        this.copyAddress();
      }
    },
    copyAddress() {
      this.v.factAddress.$model = cloneDeep(this.v.address.$model);
      this.componentKey += 1;
    },
  },
};
</script>
